"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDecisionTitle = exports.cleanJuridictionRoom = exports.cleanDecisionData = void 0;
var cleanDecisionData_1 = require("./cleanDecisionData");
Object.defineProperty(exports, "cleanDecisionData", { enumerable: true, get: function () { return __importDefault(cleanDecisionData_1).default; } });
var cleanJuridictionRoom_1 = require("./cleanJuridictionRoom");
Object.defineProperty(exports, "cleanJuridictionRoom", { enumerable: true, get: function () { return __importDefault(cleanJuridictionRoom_1).default; } });
var formatTitle_1 = require("./formatTitle");
Object.defineProperty(exports, "formatDecisionTitle", { enumerable: true, get: function () { return __importDefault(formatTitle_1).default; } });
__exportStar(require("./bibliographicReference"), exports);
__exportStar(require("./deletedDecisions"), exports);
__exportStar(require("./duplicates"), exports);
//# sourceMappingURL=index.js.map